import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";
import sortBy from "lodash/sortBy";

export const memberRankingSelector = createSelector(
  (state: RootState) => state.game?.game?.membersMap,
  (memberMap) => {
    const userIds = Object.keys(memberMap ?? {});

    const solvedUserIds = userIds.filter((userId) => {
      return !!memberMap?.[userId]?.solved;
    });

    return sortBy(
      solvedUserIds,
      (userId) => memberMap?.[userId].solvedTimestamp
    );
  }
);
